import type React from 'react'

export const Reporter: React.FC<{
  text?: string
  defaultText: string
  link: string
}> = ({ defaultText, link, text }) => {
  return (
    <a href={link} target="_blank" rel="noopener noreferrer">
      {text || defaultText}
    </a>
  )
}
